export default (function (obj, key) { return obj.hasOwnProperty(key); });
//# sourceMappingURL=has.js.map